import PricingPlansButton from './PricingPlansButton'

export default PricingPlansButton
